import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileDownload {
  
  downloadCsv(data: any[], filename: string = 'data.csv'): void {
    if (!data || data.length === 0) {
      console.error('No data provided for CSV download.');
      return;
    }

    // 1. Convert JSON array to CSV string
    const csvContent = this.convertToCsv(data);

    // 2. Trigger the download
    this.initiateDownload(csvContent, filename);
  }

  /**
   * Internal method to convert JSON array to a CSV string.
   * Assumes all objects in the array have the same keys/structure.
   * @param data The JSON array.
   * @returns The generated CSV content string.
   */
  private convertToCsv(data: any[]): string {
    const replacer = (_key: any, value: any) => (value === null || value === undefined) ? '' : value; // Handle null/undefined values

    // Get headers (keys of the first object)
    const header = Object.keys(data[0]);

    // Create the header row
    let csv = header.join(',') + '\n';

    // Create the data rows
    const rows = data.map(row =>
      header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(',')
    );

    csv += rows.join('\n');
    return csv;
  }

  /**
   * Internal method to create a Blob and trigger the file download in the browser.
   * @param content The CSV string content.
   * @param filename The name of the file.
   */
  private initiateDownload(content: string, filename: string): void {
    // Create a Blob with the CSV content and specify the MIME type
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });

    // Create a temporary URL for the blob
    const url = URL.createObjectURL(blob);

    // Create a temporary <a> element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename); // Set the filename

    // Append to the document, click, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the object URL to free up memory
    URL.revokeObjectURL(url);
  }
}
